<mat-label style="transform: scale(0.75) translateY(-7.75px)"
  >{{ label() }}
  @if (info()) {
    <span
      [siaTooltip]="info() ?? ''"
      position="right"
      class="sia-info"
      [innerHTML]="infoIcon()"
    >
    </span>
  }
</mat-label>
<mat-slider
  [min]="minValue()"
  [max]="maxValue()"
  step="1"
  color="primary"
  [class]="inputClass()"
  [isLast]="true"
  (ngInit)="setElementColor()"
  [disabled]="isDisabled()"
  [discrete]="false"
  [id]="id() ?? ''"
  [tabindex]="tabDisabled() ? '-1' : '0'"
  class="sia-mat-slider"
>
  <input
    matSliderThumb
    [ngModel]="value()"
    (ngModelChange)="handleValueChange($event)"
  />
</mat-slider>
<span class="sia-slider-description">
  {{ description() }}
</span>
